<template>
  <div class="report" :key="'view' + $route.path">
  	<RealtorInsights/>
  	<ConsumerHighlights/>
  	<BehaviouralInsights/>
  	<Footer :isTablet="isTablet" bgbox>
  		<template v-slot:details>
				<h2 v-html="_translate('report.footer.report.title')"></h2>
        <p v-html="footerContent"></p>
        <p v-html="_translate('report.footer.report.paragraph2')"></p>
        <div class="share">
          <span class="share__label" v-html="_translate('report.intro.share')"></span>
          <SocialShare platform="email"/>
          <SocialShare platform="facebook"/>
          <SocialShare platform="twitter"/>
          <SocialShare platform="linkedin"/>
        </div>
      </template>
  		<template v-slot:cta>
				<p v-html="_translate('report.footer.report.insights.text')"></p>
        <Button :href="getLocaldPath" :text="_translate('report.footer.report.insights.button')" inline></Button>
			</template>			
  	</Footer>
  </div>
</template>

<script>

	import BgBox from '@/components/BgBox.vue'
	import SocialShare from '@/components/SocialShare.vue'
	import Button from '@/components/Button.vue'

	import RealtorInsights from '@/modules/RealtorInsights.vue'
	import ConsumerHighlights from '@/modules/ConsumerHighlights.vue'
	import BehaviouralInsights from '@/modules/BehaviouralInsights.vue'
	import Footer from '@/modules/Footer.vue'

	import objectFitImages from 'object-fit-images'

	export default {

	  name: 'report',
	  
	  components: {
	  	BgBox,
	  	Button,
	  	SocialShare,
	  	RealtorInsights,
	  	ConsumerHighlights,
	  	BehaviouralInsights,
	  	Footer
	  },

	  mounted: function() {
	  	objectFitImages();
	  },

	  computed: {

	  	isTablet: function() {
	  		return this.$parent.isTablet;
	  	},

	  	getLocaldPath: function() {
	  		return this.$parent.$data.localpath;
	  	},

 			footerContent: function() {

        var content  = this._translate('local.footer.paragraph1'),
            linkText = this._translate('foresee.linktext'),
            FSRcode  = this._translate('foresee.report.code')

        var FSRcheck = ( window.loadForeSee !== undefined );
        if ( FSRcheck ) {
        	content = content.replace(linkText, '<a href="#" onclick="FSR.launchFeedback(\'' + FSRcode + '\'); return false;">' + linkText + '</a>');
      	}
      	
        return content;

      }	  	
	  }

	}

</script>

<style lang="scss">


</style>
